// extracted by mini-css-extract-plugin
export default {"header":"HeaderOrder_header__m1t3I","header__inner":"HeaderOrder_header__inner__9oBxF"};